import { encounterZoneLabel } from '../janus-engine/compile/encounter-zone-label';
import { layerOf } from './array-types';
import { decodeHtmlEntitiesForPlainText } from './decode-html-entities';

/** Saved encounter joins carry the formatter inputs, including zero and empty prefixes. */
export function savedEncounterLinkZone(source: unknown): string {
    if (!source || typeof source !== 'object' || Array.isArray(source)) return '';
    const row = source as Record<string, unknown>;
    return decodeHtmlEntitiesForPlainText(row.encounters ? encounterZoneLabel(row, false) : layerOf(row, 'location_zone') ?? '');
}

/** The same mount hook covers page chrome and asynchronous object-card fragments. */
export function hydrateEncounterLinkZones(root: ParentNode): void {
    root.querySelectorAll<HTMLElement>('[data-ft-encounter-link-zone]').forEach(element => {
        element.textContent = savedEncounterLinkZone(JSON.parse(element.getAttribute('data-ft-encounter-link-zone') || 'null'));
    });
}
